enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}
export { MediaType };
